import { useQuery } from '@apollo/client';
import React from 'react';
import classNames from 'classnames';
import { ProxyGraphClients, abgGraphqlClient } from '@atlassian/temp-client-utils';
import {
  FetchBillingAdminsForTransactionAccountPpcQuery,
  FetchBillingAdminsForTransactionAccountPpcQueryVariables,
} from '@css-xp/ppc-graphtypes';
import { TableHeading } from '@css-xp/ppc-common';
import { fetchBillingAdminsForTransactionAccountPPC } from '../../../../../../queries';
import { BillingAdmins } from './billing-admins';

export interface BillingAdminsTabProps {
  label: string;
  transactionAccountId: string;
  partnerAccountId?: string;
  validDomains: string[];
  isLoggedInUserACustomerAdvocate?: boolean;
  billingAdminIds?: string[];
  areBillingAdminIdsBeingFetched?: boolean;
  version?: number;
  isLoading?: boolean;
}

export const BillingAdminsTab = (props: BillingAdminsTabProps) => {
  const {
    transactionAccountId,
    label,
    partnerAccountId,
    validDomains,
    areBillingAdminIdsBeingFetched = false,
    isLoggedInUserACustomerAdvocate = false,
    billingAdminIds = [],
    version,
    isLoading = false,
  } = props;

  const ppcBffGraphqlClient = React.useMemo(() => abgGraphqlClient(ProxyGraphClients.PPC_BFF), []);

  const { data, loading, refetch } = useQuery<
    FetchBillingAdminsForTransactionAccountPpcQuery,
    FetchBillingAdminsForTransactionAccountPpcQueryVariables
  >(fetchBillingAdminsForTransactionAccountPPC, {
    variables: {
      id: transactionAccountId,
      billingAdminOptions: {
        partnerAccountId: partnerAccountId as string,
        billingAdminIds,
      },
    },
    client: ppcBffGraphqlClient,
    displayName: `fetchBillingAdmins`,
    notifyOnNetworkStatusChange: true,
    nextFetchPolicy: 'cache-first',
  });

  const billingAdminConnection = data?.transactionAccount?.billingAdmins;
  const billingAdmins = billingAdminConnection?.edges || [];

  return (
    <div
      className={classNames('billing-admin-details', {
        'billing-admin-details-v2': version === 2,
      })}
    >
      <BillingAdmins
        {...(!version && {
          beforeTable: <TableHeading>{label}</TableHeading>,
        })}
        billingAdmins={billingAdmins.map((billingAdmin) => ({
          fullName: billingAdmin?.node.fullName ?? '',
          email: billingAdmin?.node.email ?? '',
          isPartnerAdmin: billingAdmin?.node.isPartnerAdmin ?? false,
          picture: billingAdmin?.node.picture ?? '',
          atlassianAccountId: billingAdmin?.node.atlassianAccountId ?? '',
        }))}
        loading={loading || (areBillingAdminIdsBeingFetched && isLoggedInUserACustomerAdvocate) || isLoading}
        refetch={refetch}
        transactionAccountId={transactionAccountId}
        isRemoveDisabled={billingAdminConnection?.disableRemoveFeature ?? false}
        validDomains={validDomains}
        partnerAccountId={partnerAccountId}
        version={version}
      />
    </div>
  );
};
